import  {cardData}  from "./data";
import './index.css'
function CardComponent({ img, heading, text, range = [0,2] ,gridValue}) {
  return ( 
    <div className={`grid grid-cols-1 sm:grid-cols-1  md:grid-cols-${gridValue}  gap-10 md:gap-8 lg:gap-3 xl:gap-8  container`}>
      {cardData.slice(...range).map((list,index) => (
        <div key={index} className=" w-full rounded-lg overflow-hidden  shadow-[0_20px_25px_-5px_rgb(85_85_85_/_10%),_0_8px_10px_-6px_rgb(255_255_255_/_10%)] border bg[#f3ebfa] bg-gray-50">
          <div className="px-5 xl:px-4  pt-4 lg:pt-8 flex justify-center items-center py-5 space-x-5 min-h-10 lg:min-h-36 xl:min-h-20 bg-white" >
            <div> 

               <img
                src={list.img} 
                alt={list.altText}
                loading="lazy"
                className=" w-20 h-20 md:w-24 md:h-24 object-contain "
                />
                 </div>
            <h4 className="text-[18px] lg:text-[20px] xl:text-[22px] 2xl:text-[25px] leading-[1.2] text-dark font-bold ">
              {list.heading}{" "} 
            </h4>
          </div>
          <div className=" px-6 py-3 md:py-6">
            <p className="text-base leading-[1.625rem] ">{list.text}</p>
          </div>
        </div>
    ))}
    </div>
  );
}
export default CardComponent;
